export const slickAmbassadorForYouSettings = {
  infinite: true,
  speed: 600,
  autoplaySpeed: 5000,
  autoplay: true,
  arrows: true,
  mobileFirst: true,
  swipe: true,
  dots: false,
  centerPadding: '1px',
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1055,
      settings: {
        centerMode: false,
        variableWidth: false,
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
    {
      breakpoint: 770,
      settings: {
        centerMode: false,
        variableWidth: false,
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 812,
      settings: {
        centerMode: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        variableWidth: false,
      },
    },
    {
      breakpoint: 480,
      settings: {
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
      },
    },
  ],
};
